import { HTTPService } from './httpService';
import { normalizeEmail } from '../util/userIdentity';

const API = new HTTPService();

/**
 * Add an EXISTING user to a company. Add-only on the server: it never changes a
 * link the person already has, so a group-wide admin linked as a "contact" keeps
 * their scope and role. Deliberately NOT POST /user-companies/:userId, which
 * rewrites role and location in place.
 *
 * Body mirrors POST /users: for a dealer, companyId is the dealer id and the
 * server resolves the group.
 */
export async function linkUserToCompany(userId, { companyId, userType, role, location_id }) {
  const { data } = await API.post(`/users/${userId}/companies`, {
    companyId, userType, role, location_id,
  });
  return data || {};
}

/** Give an existing, login-less user a Cognito login + invite. */
export async function createLoginForUser(userId, email) {
  const { data } = await API.post('/auth/create-user', { userId, email: normalizeEmail(email) });
  return data;
}
